import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { ReactComponent as CancelIcon } from "../../assets/images/svgs/CancelConfirmation.svg"

const headerStyle = {
  paddingBottom: "2px",
  fontSize: "large",
};

const buttonStyle = {
  paddingBottom: "1rem",
};

const ConfirmationPopup = ({
  open,
  onClose,
  title,
  content,
  onConfirm,
}) => {
  return (
    <Dialog
      style={{ borderRadius: "10px !important" }}
      open={open}
      onClose={() => onClose(false)}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "300px",
        }}
      >
        <CancelIcon width={150} height={150} style={{marginTop: "2rem"}} />
        <DialogTitle style={headerStyle}>{title}</DialogTitle>
        <DialogContent>
          <Typography
            sx={{
              color: "#535862",
              fontSize: "small",
              textAlign: "center",
            }}
          >
            {content}
          </Typography>
        </DialogContent>
        <DialogActions style={buttonStyle}>
          <Button sx={{textTransform: "none"}} onClick={() => onClose(false)} className="btn-secondary">
            Cancel
          </Button>
          <Button sx={{textTransform: "none"}} onClick={() => onConfirm(true)} className="btn-primary">
            Confirm
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ConfirmationPopup;
